import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaModule, PageComponentModule, ProductListItemContextSource } from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { CustomProductCarouselComponent } from './product-carousel.component';
import { CustomProductCarouselItemComponent } from '../product-carousel-item/product-carousel-item.component';
import { CustomCarouselModule } from '../../carousel/carousel.module';
import { CarouselModule } from 'primeng/carousel';

@NgModule({
  imports: [
    CommonModule,
    CustomCarouselModule,
    MediaModule,
    RouterModule,
    UrlModule,
    I18nModule,
    PageComponentModule,
    CarouselModule,
    CustomProductCarouselItemComponent,
  ],
  providers: [
    ProductListItemContextSource,
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductCarouselComponent: {
          component: CustomProductCarouselComponent,
        },
      },
    }),
  ],
  declarations: [CustomProductCarouselComponent],
  exports: [CustomProductCarouselComponent],
})
export class CustomProductCarouselModule {}
